import React from 'react';
import styled from 'styled-components';
import commonLogo from '../assets/game_logos/common.png';

import CircularProgress from '@material-ui/core/CircularProgress';

const Div = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  position: relative;
  align-self: stretch;
  align-items: center;
  flex-direction: column;
  justify-content: center;
`;

const Logo = styled.img`
  width: 250px;
  margin-bottom: 2em;
`;

const Loading = () => {
  return (
    <Div>
      <Logo alt="GAMEGOS" src={commonLogo} />
      <CircularProgress />
    </Div>
  );
};

Loading.propTypes = {};

Loading.defaultProps = {};

export default Loading;
